<template>
    <div class="vessel-stat-counter">
        <div class="stat-circle" :style="{ backgroundColor: color }">
            <span class="material-icons stat-icon">{{ icon }}</span>
            <span class="icon-tally" :style="{ backgroundColor: displayValue == 0 ? 'mediumseagreen' : 'red' }">{{ displayValue }}</span>
        </div>
        <div class="stat-label">{{ label }}</div>
    </div>
</template>

<script>
export default {
    props: {
        label: { type: String, required: true },
        value: { type: Number, default: 0 },
        color: { type: String, default: '#333333' },
        icon: { type: String, default: '' },
        animDelay: { type: Number, default: 0 },
        animated: { type: Boolean, default: true }
    },

    data() {
        return {
            displayValue: 0,
            animTimer: null
        };
    },

    watch: {
        value(newVal) {
            if (this.animated) {
                this.startAnimation(newVal);
            } else {
                this.displayValue = newVal;
            }
        }
    },

    mounted() {
        if (!this.animated) {
            this.displayValue = this.value;
            return;
        }
        if (this.value > 0) {
            this.startAnimation(this.value);
        }
    },

    beforeUnmount() {
        if (this.animTimer) clearInterval(this.animTimer);
    },

    methods: {
        startAnimation(target) {
            if (this.animTimer) {
                clearInterval(this.animTimer);
                this.animTimer = null;
            }
            this.displayValue = 0;
            if (target <= 0) return;

            setTimeout(() => {
                const duration = 800;
                const intervalMs = 16;
                const steps = Math.round(duration / intervalMs);
                const increment = target / steps;
                let current = 0;

                this.animTimer = setInterval(() => {
                    current += increment;
                    if (current >= target) {
                        this.displayValue = target;
                        clearInterval(this.animTimer);
                        this.animTimer = null;
                    } else {
                        this.displayValue = Math.round(current);
                    }
                }, intervalMs);
            }, this.animDelay);
        }
    }
};
</script>

<style scoped>
.vessel-stat-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-width: 80px;
}

.stat-circle {
    position: relative;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.stat-icon {
    color: #fff;
    font-size: 1.8rem;
}

.icon-tally {
    position: absolute;
    font-size: 0.75rem;
    color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -8px;
    right: -8px;
    font-weight: bold;
}

.stat-label {
    font-size: 0.7rem;
    font-weight: 600;
    text-align: center;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1.3;
    max-width: 80px;
}
</style>
